import _ from '@/utils/lodash-optimized'
import React from 'react'
import './styles.scss'

import ChangeRenderer from './ChangeRenderer'
import ValueRenderer from './ValueRenderer'

const Header = ({ header }) => (
  <thead>
    <tr>
      <th>Change</th>
      {header.map((item, index) => (
          <th key={index}>{item?.title}</th>
      ))}
    </tr>
  </thead>
)

export class TableChangesSection extends React.Component {
  renderBody () {
    const { section } = this.props

    const renderRow = (row, rowKey, className) => (
      <tr
        key={rowKey}
        className={className}
      >
        <td>{className}</td>
        {row.items.map((item, index) => {
          if (item.change) {
            return (
              <td key={index}>
                <ChangeRenderer
                  change={item.change}
                  type={item.type}
                />
              </td>
            )
          }
          return (
            <td key={index}>
              <ValueRenderer
                value={item.value}
                type={item.type}
              />
            </td>
          )
        })}
      </tr>
    )

    let rows = [];
    rows = rows.concat(
      section.deleted.map((r, i) => renderRow(r, "deleted" + i, "deleted"))
    );
    rows = rows.concat(
      section.added.map((r, i) => renderRow(r, "added" + i, "added"))
    );
    rows = rows.concat(
      section.changed.map((r, i) => renderRow(r, "changed" + i, "updated"))
    );

    return <tbody>{rows}</tbody>
  }

  renderNoData () {
    const { section } = this.props
    return (
      <tbody>
        <tr>
          <td
            className='nodata'
            colSpan={section.header.length}
          >
            No Data Present
          </td>
        </tr>
      </tbody>
    )
  }

  render () {
    const { section } = this.props

    if (_.isNil(section)) {
      return null
    }

    const isDataPresent = !(
      _.isEmpty(section.changed) &&
      _.isEmpty(section.added) &&
      _.isEmpty(section.deleted)
    )

    return (
      <div className='table-changes-section'>
        <table>
          {isDataPresent && section.header
            ? (
              <Header header={section.header} />
            )
            : null}
          {isDataPresent ? this.renderBody() : this.renderNoData()}
        </table>
      </div>
    )
  }
}
